import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';

import { AuthService } from './services/auth.service';
import { IUserInfo } from './admin/models/user.interface';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  showMenu: boolean = false;
  userInfo: IUserInfo = undefined as any;
  constructor(private platform: Platform, public authService: AuthService) {
    this.initializeApp()
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.authService.onCheckAuth.subscribe((data) => {
        console.debug('AppComponent - onCheckAuth', data);
        this.showMenu = data ? true : false;
        this.userInfo = data;
      });
    });
  }
}
